import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const abortTableSplit = (splitId, tableId, data, hasModalLogin = true) => {
	return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
		.post(`/tables/${tableId}/splits/${splitId}/abort`, data)
}

export default abortTableSplit
